import $ from 'jquery';

/**
 * Video Modal Class
 */
class VideoModal {
    /**
     * Initilization Function
     * @returns {void}
     */
    init() {
        this.clickEventHandler();
    }

    /**
     * Function that handles click events
     * @returns {void}
     */
    clickEventHandler() {
        // Toggle open/close nav on hamburger click
        $('.video-play-button.-modal').on('click', (e) => {
            const videoID = $('.video-play-button.-modal').data('vidid');
            const videoService = $('.video-play-button.-modal').data('vidservice');

            if  (videoID !== '' && videoService !== '') {
                e.preventDefault();

                let iframe = ``;

                if (videoService == 'youtube') {
                    iframe = `
                        <iframe id="ytplayer" type="text/html" width="640" height="360"
                        src="https://www.youtube.com/embed/${videoID}"
                        frameborder="0"></iframe>
                    `;
                } else if (videoService == 'vimeo') {
                    iframe = `
                        <iframe src="https://player.vimeo.com/video/${videoID}"
                        width="640" height="360" frameborder="0" webkitallowfullscreen
                        mozallowfullscreen allowfullscreen></iframe>
                    `;
                }

                const modal = `
                    <div class="video-modal">
                        <i class="fas fa-times video-modal-close"></i>
                        <div class="spinning-loader"></div>
                        ${iframe}
                    </div>
                `;

                $('body').append(modal);
                $('body').toggleClass('menu');
            }
        });

        $(document).on('click', (e) => {
            const $target = e.target;

            if ($($target).hasClass('video-modal-close') || $($target).parent().hasClass('video-modal-close')) {
                $('.video-modal').remove();
                $('body').toggleClass('menu');
            }
        });

        $(".video-hero .scroll, .video-hero .bottom, .video-hero svg, .video-hero svg path").click(() => {
            $('html, body').animate({
                scrollTop: $("#top-of-content").offset().top
            }, 1000);
        });
    }
}

export default VideoModal;